const parallaxStyle = {
  parallax: {
    height: "40vh",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "75% 96%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "700px 460px",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center"
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.045)"
      /* background: "rgb(52,79,147)",
      background:
        "linear-gradient(90deg, rgba(76,160,195,1) 0%, rgba(60,47,209,0.0002) 95%, rgba(31,20,89,0) 100%)" */
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  small: {
    height: "500px"
  },
  medium: {
    height: "90vh"
  }
};

export default parallaxStyle;
